import { environment } from '../../../environments/environment';

/**
 * Auth0 `app_metadata` of the ID token (custom claim, older tokens use `appMetadata`).
 */
export function getAppMetadataClaim(idTokenClaims: Record<string, any> | null | undefined): Record<string, any> | undefined {
  return idTokenClaims?.[`${environment.auth0_custom_claims_prefix}app_metadata`] ?? idTokenClaims?.[`${environment.auth0_custom_claims_prefix}appMetadata`];
}

/**
 * Only a SmartHead administrator (`app_metadata.sh_admin` = 1) may use the administration application.
 */
export function isShAdmin(appMetadata: Record<string, any> | null | undefined): boolean {
  return appMetadata?.['sh_admin'] === 1;
}
